export default "__VITE_ASSET__Csz0R_HR__"